export function getAddBookingDisabledReason({
  isConnectedToStripe,
  page,
}: {
  isConnectedToStripe?: boolean;
  page?: { status?: string };
}): string | null {
  if (!isConnectedToStripe) return 'Connect a Stripe account to add bookings';
  if (page?.status !== 'published') return 'Publish this event before adding bookings';
  return null;
}
